module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-layout"
  }, [_c('div', {
    ref: "scroller",
    staticClass: "scroller",
    on: {
      "scroll": function () {
        this$1.$emit('scroll', this$1.$refs.scroller.scrollTop)
      }
    }
  }, [_vm._t("scroller")], 2), _vm._v(" "), _c('div', [_vm._t("tab")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b40926c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TabLayout.vue
// module id = 624
// module chunks = 1